import { getPermissionRequestContext, type PermissionRequestContext } from './app-error';

export const PERMISSION_REQUEST_EVENT = 'ironview:permission-request';

export const showPermissionRequestPrompt = (error: unknown): boolean => {
  const context = getPermissionRequestContext(error);
  if (!context || typeof window === 'undefined') return false;

  window.dispatchEvent(
    new CustomEvent<PermissionRequestContext>(PERMISSION_REQUEST_EVENT, {
      detail: context,
    }),
  );
  return true;
};
